import styled from 'styled-components'

const ListItemName = styled.dt`
  font-size: 14px;
`

export default ListItemName
